import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, BarChart3, Clock, Trophy, Target } from 'lucide-react';

const StatsSelection = ({ 
  currentTheme, 
  selectedStats, 
  onStatSelection, 
  onBack, 
  onShareStats, 
  t 
}) => {
  const availableStats = [
    {
      id: 'productivity',
      title: t('identityCircle.stats.productivity', 'Verimlilik'),
      icon: Target,
      value: '85%',
      description: t('identityCircle.stats.productivityDesc', 'Bu hafta tamamlanan görevler'),
      color: 'blue'
    },
    {
      id: 'focus',
      title: t('identityCircle.stats.focus', 'Odaklanma'),
      icon: Clock,
      value: '6.5h',
      description: t('identityCircle.stats.focusDesc', 'Günlük ortalama odaklanma süresi'),
      color: 'green'
    },
    {
      id: 'achievements',
      title: t('identityCircle.stats.achievements', 'Başarılar'),
      icon: Trophy,
      value: '12',
      description: t('identityCircle.stats.achievementsDesc', 'Bu ay kazanılan rozetler'),
      color: 'yellow'
    },
    {
      id: 'growth',
      title: t('identityCircle.stats.growth', 'Gelişim'),
      icon: BarChart3,
      value: '+24%',
      description: t('identityCircle.stats.growthDesc', 'Geçen aya göre artış'),
      color: 'purple'
    }
  ];

  const getColorClasses = (color, isSelected) => {
    const colors = {
      blue: isSelected ? 'bg-blue-500 border-blue-500 text-white' : 'bg-blue-50 border-blue-200 text-blue-700',
      green: isSelected ? 'bg-green-500 border-green-500 text-white' : 'bg-green-50 border-green-200 text-green-700',
      yellow: isSelected ? 'bg-yellow-500 border-yellow-500 text-white' : 'bg-yellow-50 border-yellow-200 text-yellow-700',
      purple: isSelected ? 'bg-purple-500 border-purple-500 text-white' : 'bg-purple-50 border-purple-200 text-purple-700'
    };
    return colors[color];
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      className="space-y-6"
    >
      <div className="flex items-center space-x-4">
        <button
          onClick={onBack}
          className={`p-2 hover:${currentTheme.accentLight} rounded-full transition-colors`}
        >
          <ArrowLeft size={20} className={currentTheme.textSecondary} />
        </button>
        <div>
          <h2 className={`text-2xl font-bold ${currentTheme.textPrimary}`}>
            {t('identityCircle.stats.title', 'İstatistik Seç')}
          </h2>
          <p className={`${currentTheme.textSecondary}`}>
            {t('identityCircle.stats.subtitle', 'Paylaşmak istediğiniz istatistikleri seçin')}
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {availableStats.map((stat) => {
          const Icon = stat.icon;
          const isSelected = selectedStats.some(s => s.id === stat.id);
          
          return (
            <motion.button
              key={stat.id}
              onClick={() => onStatSelection(stat)}
              className={`p-6 rounded-xl border-2 transition-all text-left ${getColorClasses(stat.color, isSelected)}`}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <div className="flex items-start justify-between mb-4">
                <div className="flex items-center space-x-3">
                  <Icon size={24} />
                  <div>
                    <h3 className="font-semibold">{stat.title}</h3>
                    <p className="text-sm opacity-70">{stat.description}</p>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-2xl font-bold">{stat.value}</div>
                </div>
              </div>
              
              {isSelected && (
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  className="w-6 h-6 bg-white rounded-full flex items-center justify-center ml-auto"
                >
                  <div className="w-3 h-3 bg-current rounded-full" />
                </motion.div>
              )}
            </motion.button>
          );
        })}
      </div>

      <div className={`text-center ${currentTheme.textMuted}`}>
        <p>
          {selectedStats.length > 0 
            ? t('identityCircle.stats.selected', `${selectedStats.length} istatistik seçildi`)
            : t('identityCircle.stats.selectHint', 'Paylaşmak için istatistikleri seçin')
          }
        </p>
      </div>
    </motion.div>
  );
};

export default StatsSelection;
